var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-account bc-white"},[_c('Filter_ui'),_c('div',{staticClass:"main"},[_c('Page_'+_vm.$store.state.ui.ui_page,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }